import { configureStore } from "@reduxjs/toolkit";
import { inventoryApi } from "../featureSlice/inventorySliceApi";
import { mealItemApi } from "../featureSlice/mealItemSliceApi";
import { mealSliceApi } from "../featureSlice/mealSliceApi";
import { analyticsApi } from "../featureSlice/analtyicsSliceApi";
import { rfidRegistrationSliceApi } from "../featureSlice/rfidRegistrationSliceApi";
import { employeeApi } from "../featureSlice/employeeApi";
import { authApi } from "../featureSlice/auth/authSlice";


export const store = configureStore({
  reducer: {
        [authApi.reducerPath]: authApi.reducer,

    [inventoryApi.reducerPath]: inventoryApi.reducer,
    [mealItemApi.reducerPath]: mealItemApi.reducer,
    [mealSliceApi.reducerPath]: mealSliceApi.reducer,
    [analyticsApi.reducerPath]: analyticsApi.reducer,
    [rfidRegistrationSliceApi.reducerPath]: rfidRegistrationSliceApi.reducer,
    [employeeApi.reducerPath]: employeeApi.reducer,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(inventoryApi.middleware)
      .concat(mealItemApi.middleware)
      .concat(mealSliceApi.middleware)
      .concat(analyticsApi.middleware)
      .concat(rfidRegistrationSliceApi.middleware)
      .concat(employeeApi.middleware)
            .concat(authApi.middleware),

});
